export default function NavBackScroll () {

  const navItems = document.querySelectorAll('.nav-header');

  const setInitialOffset = () => {  
    if (window.innerWidth > 700){
      return document.querySelector('.desktop-nav').offsetHeight;
    } else {
      return document.querySelector('.mobile-nav').offsetHeight;
    }
  }

  const viewportHeight = setInitialOffset();
  let previousScrollPosition = 0;

  const isScrollingUp = () => {
    let scrollingUp = false;
    let scrollPosition = window.pageYOffset;
    if (scrollPosition < previousScrollPosition) {
      scrollingUp = true;
    }
    previousScrollPosition = scrollPosition;
    return scrollingUp;
  };

 

  let lastScrollPosition = 0,
    tick = false; 

  window.addEventListener('scroll', function(e) {
    if (!tick) {
      window.requestAnimationFrame(function() {
        lastScrollPosition = window.scrollY;
        navItems.forEach(navItem => {
          if (lastScrollPosition > viewportHeight){
            navItem.classList.add('backscroll');
          } else {
            navItem.classList.remove('backscroll');
          }
        });
      
        if ((isScrollingUp() && lastScrollPosition > viewportHeight)) {
          navItems.forEach(navItem => {
            navItem.classList.add('backscroll--visible');
          })
        } else {
          navItems.forEach(navItem => {
            navItem.classList.remove('backscroll--visible');
          })
        }
        tick = false;
      });
      tick = true;
    }
  });
}